import { render, staticRenderFns } from "./domain-card.vue?vue&type=template&id=639f38d2&scoped=true"
import script from "./domain-card.ts?vue&type=script&lang=ts&external"
export * from "./domain-card.ts?vue&type=script&lang=ts&external"
import style0 from "./domain-card.scss?vue&type=style&index=0&id=639f38d2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639f38d2",
  null
  
)

export default component.exports